export function getTime(date) {
  return date.toLocaleTimeString("nl", {
    hour: "numeric",
    minute: "numeric",
    hour12: false,
  });
}
